export const headerText = (): string => "vonLuck";
